import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { PrimeNGConfig } from 'primeng/api';
import { IDataColumn } from '@shared/interfaces/data-column.interface';
import { IDataAction } from '@shared/interfaces/data-action.interface';
import { IBooking } from '@shared/interfaces/bookings.interface';
import { BookingService } from '@shared/services/booking.service';
import { es } from 'date-fns/locale';

@Component({
  selector: 'app-cardtable',
  templateUrl: './cardtable.component.html',
  styleUrls: ['./cardtable.component.scss']
})
export class CardtableComponent implements OnInit {

  @Input() bookingsData!: any;
  @Input() title: string = '';
  @Input() linkmore: string = '';
  @Input() textmore: string = '';
  @Input() size: string = '';
  @Input() datacolumns: IDataColumn[] = [];
  @Input() datavalues: any[] = [];
  @Input() dataactions: IDataAction[] = [];
  @Input() globalfilters: Array<string> = [];
  @Input() showActionLabels: boolean = false;
  @Input() debug: boolean = false;
  @Input() searcher: string = '';
  @ViewChild('dt') dt!: Table;
  type: string | undefined;
  bookingData: any = {};

  @Output()
  eventTriggered = new EventEmitter<{action:string, value:any}>();

  public filteredData: any[] = [];
  public consultBooking: boolean = false;
  public locale: Locale = es;
  public selectColour: string = '';


  _globalFilters: Array<string> = [];

  constructor(private config: PrimeNGConfig, private bookingService: BookingService) { }

  ngOnInit(): void {
    if(this.debug){
      // console.log('CardtableComponent setup', this.datavalues, this.dataactions);
    }
    this._globalFilters = this.setGlobalFilter();
  }

  openConsult(bookingData: IBooking) {
    this.consultBooking = true;
    this.bookingData = bookingData;
  }

  closeConsultBooking(){
    this.consultBooking = false;
  }

  setGlobalFilter(): string[] {
    return this.globalfilters;
  }

  filterValue(event: any){
    this.dt.filterGlobal(event.value, 'contains')
  }

  getComplexColumn(column: string, obj: any) {
    const columnParts = column.split('.');
    let result = obj;
    for (const part of columnParts) {
      if (result && result.hasOwnProperty(part)) {
        result = result[part];
      } else {
        result = null;
        break;
      }
    }
    return result;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  }


}
